import React, { Fragment } from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';

import PageTitle from '../../components/shared/page-title';
// import SectionHeader from "../../components/shared/sectionheader";
import QuestionsForYou from '../../components/write-answers/questions-for-you';
import AnswerRequests from '../../components/write-answers/requests';
import AnswerLater from '../../components/write-answers/saved';

import style from './index.module.scss';

function Nav() {
  return (
    <nav className={style.nav}>
      <NavLink
        to="/answer"
        exact
        activeClassName={style['nav-link--active']}
        className={style['nav-link']}
      >
        For You
      </NavLink>
      <NavLink
        to="/answer/requests"
        className={style['nav-link']}
        activeClassName={style['nav-link--active']}
      >
        <span className={style['nav-link-total-answers']}>2</span>{' '}
        <span>
          <span className={style['nav-link-label']}>Answer</span> Requests
        </span>
      </NavLink>
      <NavLink
        to="/answer/saved"
        className={style['nav-link']}
        activeClassName={style['nav-link--active']}
      >
        <span className={style['nav-link-total-answers']}>8</span>{' '}
        <span className={style['nav-link-label']}>Answer Later</span>{' '}
        <span className={style['nav-link-label-mobile']}>Saved</span>
      </NavLink>
    </nav>
  );
}

function WriteAnswersPage() {
  return (
    <Fragment>
      <PageTitle
        pageTitle="Quora - Write Answers"
        pageDesc="Write Answers page of Quora"
      />
      <div className={`${style['to-answer']}`}>
        <div className={style['mobile-nav']}>
          <Nav />
        </div>
        <div className={`row`}>
          <aside className={`col ${style['col--side-nav']}`}>
            <Nav />
          </aside>
          <section className={`col ${style['col--main-content']}`}>
            <Switch>
              <Route path="/answer" exact component={QuestionsForYou} />{' '}
              <Route path="/answer/requests" component={AnswerRequests} />
              <Route path="/answer/saved" component={AnswerLater} />
            </Switch>
          </section>
          <aside className={`col ${style['col--add-topics']}`}>
            Add Topics
          </aside>
        </div>
      </div>
    </Fragment>
  );
}

export default WriteAnswersPage;
